/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a line item's match group assignment
 * @export
 * @interface UpdateLineItemMatchGroupRequest
 */
export interface UpdateLineItemMatchGroupRequest {
    /**
     * ID of the match group to assign this item to. Pass null to unmatch.
     * @type {number}
     * @memberof UpdateLineItemMatchGroupRequest
     */
    lineItemMatchGroupId: number | null;
}

/**
 * Check if a given object implements the UpdateLineItemMatchGroupRequest interface.
 */
export function instanceOfUpdateLineItemMatchGroupRequest(value: object): value is UpdateLineItemMatchGroupRequest {
    if (!('lineItemMatchGroupId' in value) || value['lineItemMatchGroupId'] === undefined) return false;
    return true;
}

export function UpdateLineItemMatchGroupRequestFromJSON(json: any): UpdateLineItemMatchGroupRequest {
    return UpdateLineItemMatchGroupRequestFromJSONTyped(json, false);
}

export function UpdateLineItemMatchGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLineItemMatchGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItemMatchGroupId': json['lineItemMatchGroupId'],
    };
}

export function UpdateLineItemMatchGroupRequestToJSON(json: any): UpdateLineItemMatchGroupRequest {
    return UpdateLineItemMatchGroupRequestToJSONTyped(json, false);
}

export function UpdateLineItemMatchGroupRequestToJSONTyped(value?: UpdateLineItemMatchGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItemMatchGroupId': value['lineItemMatchGroupId'],
    };
}

